<template lang="pug">
	.asset-video-generation-edit(v-if="showed && creative && image" v-window)
		.card(@click.stop)
			.card-header
				i.fa.fa-film
				span AI Image to Video
			.card-body.collapse.show
				.form-line.image.separator
					.videos(:class="{centered: true}")
						.video(:style="{backgroundImage: `url(${image.path})`}")
							.start-frame-label Start frame
							span.attached-images +1 start frame reference
				.form-line
					AssetVideoGenerationSettings(ref="settings" :creative="creative" :asset="asset" @change="updateSettings($event)")
				.form-actions
					.collapsing-buttons
						button.btn.btn-primary(type="button" @click="generate()")
							i.fa.fa-film
							span Generate video
					button.btn.btn-dark.right-button(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 								from '../../mixins/screen'

	import AssetVideoGenerationSettings			from './AssetVideoGenerationSettings'

	export default {
		name: "AssetVideoGenerationEdit",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Creative Generations Loaded",
				"Selected Creative Generation Added",
				"Selected Creative Generation Changed: [status]",
				"Selected Creative Generation Removed",
				"Selected Creative Asset Uploads Loaded",
				"Selected Creative Asset Upload Added",
				"Selected Creative Asset Upload Removed",
				"Selected Creative Updated", // для изменения бюджета креатива
				"Selected Version Assets Changed"

			],
			events: {
				"Show AssetVideoGenerationEdit": function(creative, asset, variation, image) {

					this.creative = creative;
					this.asset = asset;
					this.variation = variation;
					this.image = image;

					// Выбранный кадр используется как стартовый кадр генерируемого видео (image to video)
					this.attachments = {[image.imageId]: true};

					this.update();

				}
			}
		},
		components: {
			AssetVideoGenerationSettings
		},
		data() {

			this.creative = null;
			this.asset = null;
			this.image = null;

			return {
				attachments: {},
				settings: {}
			}

		},
		methods: {
			collectData() {

				if (!this.creative) return;

				this.$nextTick(() => {

					if (this.$refs["settings"]) {

						this.$refs["settings"].update();
						this.$refs["settings"].setAttachmentsCount(_.size(this.attachments));

					}

				});

			},
			updateSettings(settings) {

				this.settings = settings;

			},
			generate() {

				let settings = this.$refs["settings"].getSettings();

				Server.sendToServer({
					GenerateVideo: {
						versionId: this.asset['version_id'],
						assetCodename: this.asset['codename'],
						aiVendorCodename: settings.vendorCodename,
						aiModelCodename: settings.modelCodename,
						aiSizeCodename: settings.sizeCodename,
						duration: settings.duration,
						prompt: settings.prompt,
						attachments: Object.keys(this.attachments),
						count: settings.count,
						// Генерация без ассета здесь не используется - он уже есть
						newAssetCodename: '',
						newElementType: '',
						elementScreenCodename: '',
						elementId: 0
					}
				});

				this.closeWindow();

			}
		}
	}
</script>

<style lang="sass">

	.asset-video-generation-edit
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: all .3s, opacity 0.2s

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 940px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			button
				white-space: nowrap

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				color: #fff

		.form-line
			display: flex
			flex-direction: row

		.videos
			display: flex
			flex-direction: row
			width: 100%

			&.centered
				justify-content: center

			.video
				position: relative
				flex-shrink: 0
				width: 400px
				height: 300px
				background-position: center
				background-size: contain
				background-repeat: no-repeat
				border-radius: 5px
				border: 1px solid var(--gray-dark)
				box-shadow: 0px 0px 5px var(--gray-dark)

				.start-frame-label
					position: absolute
					left: 8px
					top: 8px
					padding: 2px 8px
					border-radius: 3px
					background-color: rgba(0,0,0,0.6)
					color: #fff
					font-size: 11px

				.attached-images
					position: absolute
					right: 8px
					bottom: 8px
					color: var(--orange)
					font-size: 11px

		.form-actions
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 20px
			transition: 0.3s

			.right-button
				margin-left: auto

	.asset-video-generation-edit.hiding
		opacity: 0

		.card
			transform: scale(0.9)

</style>
